import "./changeContractOwnerPage.css";
import _ from "lodash";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useWeb3React } from "@web3-react/core";
import { Box, Container, Stack, Typography, TextField } from "@mui/material";
import { ContainButtonShort, LinearTextDialog } from "../../utils";
import { useTransferOwnership } from "../../hooks/useTransferOwnership";
import { setData } from "../status/statusSlice";
import DialogConfirm from "../../components/dialogConfirm/DialogConfirm";
import DialogStatus from "../../components/dialogStatus/DialogStatus";

import Top from "../../components/top/Top";
import IconAccountActive from "../../assets/images/icons/active/active-icon-issuer.png";
import Loading from "../../components/loading/Loading";

export const CheckContractOwner = () => {
    const { library } = useWeb3React();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { onTransferOwnership, waitConfirmTransfer } = useTransferOwnership();
    const [open, setOpen] = useState(false);
    const [openStatus, setOpenStatus] = useState(false);
    const [message, setMessage] = useState("");
    const [isError, setIsError] = useState(false);
    const [txHash, setTxHash] = useState("");
    const [address, setAddress] = useState<any>("");

    const handleOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }

    const onChangeAddress = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAddress(event.target.value);
    };

    const onChangeContractOwner = () => {
        onTransferOwnership(library.getSigner(), address)
            .then((value: any) => {
                const err = _.get(value, "err");
                const tx = _.get(value, "tx");
                const hash = _.get(value, "tx.hash");

                if (tx) {
                    handleClose();
                    setAddress("");
                    setIsError(false);
                    dispatch(setData({
                        txHash: hash,
                        message: "Update",
                        description: "Contract owner updated successfully"
                    }));
                    setTxHash(hash);
                    setMessage("Success!");
                    navigate("/status?role=admin");
                    setOpenStatus(true);
                } else {
                    handleClose();
                    setIsError(true);
                    setTxHash("");
                    setMessage(err);
                    setOpen(false);
                    setOpenStatus(true);
                }
            })
            .catch((err: any) => {
                handleClose();
                setIsError(true);
                setTxHash("");
                setMessage(err);
                setOpen(false);
                setOpenStatus(true);
            });
    };

    return (
        <Container sx={{ textAlign: "center" }}>
            <Box display="flex" flexDirection="column">
                <Top
                    title="Change Contract"
                    subTitle="Owner"
                    description="Edit the contract to update the owner on this page"
                />

                <Stack height={"50vh"} justifyContent={"center"}>
                    <Stack
                        sx={{
                            mt: 5,
                            p: 3,
                            gap: 3,
                            borderRadius: "32px !important",
                            border: "1px solid var(--black)",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignSelf: "center",
                            width: "580px !important",
                        }}
                    >
                        <Box>
                            <Typography fontSize={24} fontWeight={600}>
                                Change
                            </Typography>
                            &nbsp;
                            <LinearTextDialog>Contract Owner</LinearTextDialog>
                        </Box>
                        <Typography
                            fontSize={12}
                            fontWeight={400}
                            sx={{
                                overflowWrap: "break-word",
                                color: "var(--black)",
                                textTransform: "none",
                            }}
                        >
                            Enter the wallet address for the new contract owner
                        </Typography>

                        <Box
                            display={"flex"}
                            alignItems={"center"}
                            justifyContent={"center"}
                        >
                            <img
                                src={IconAccountActive}
                                alt="IconAccountActive"
                                width={40}
                                height={40}
                            />
                            <TextField
                                fullWidth
                                sx={{
                                    ml: 1,
                                    "& .MuiInputBase-input": {
                                        padding: "10px 24px !important",
                                        fontSize: "14px",
                                        fontWeight: 400,
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "25px",
                                        "&:hover": {
                                            borderColor: "unset",
                                        },
                                    },
                                }}
                                value={address}
                                onChange={(e: any) => onChangeAddress(e)}
                            />
                        </Box>
                        <Stack direction={"row"} justifyContent={"center"}>
                            <ContainButtonShort
                                onClick={() => handleOpen()}
                                disabled={_.isEmpty(address)}
                            >
                                Confirm
                            </ContainButtonShort>
                        </Stack>
                    </Stack>
                </Stack>
                <DialogConfirm
                    open={open}
                    onClose={() => handleClose()}
                    confirm={() => onChangeContractOwner()}
                    title="Confirm"
                    subTitle="Address"
                    description="Are you sure you want to change the contract owner?" />
                <DialogStatus
                    open={openStatus}
                    onClose={() => setOpenStatus(false)}
                    msgErr={isError}
                    // confirm={() => handleBurnTotalSupply()}
                    title="Confirm"
                    subTitle={isError ? "Error" : message}
                    description={isError ? message : txHash} />
                {waitConfirmTransfer && <Loading loading={waitConfirmTransfer} />}
            </Box>
        </Container>
    );
};

export default CheckContractOwner;
